import React, { useEffect, useState } from "react";
import "./Dashboard.css"; // still provides the shared news / alert popup styles
import "./DashboardAethrx.css";
import { useNavigate } from "react-router-dom";
import { BasicInfo, toastFailed } from "./../../Config/BasicInfo";
import { ApiPaths } from "./../../Config/ApiPath";
import useAxiosHelper from "./../../Common/AxiosHelper";
import { useSelector, useDispatch } from "react-redux";
import { setUserPersonalInfo } from "../../Redux/ProfileDataSlice";
import { setIncomeWallet } from "../../Redux/IncomeWallet";
import { setTeamSection } from "../../Redux/TeamSlice";
import moment from "moment/moment";
import { setShowDashPopup } from "../../Redux/StatusState";
import { GoAlertFill } from "react-icons/go";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import {
  TrendingUp,
  Target,
  BarChart2,
  BarChart3,
  Wallet,
  DollarSign,
  ArrowUpRight,
  ArrowDownLeft,
  ChevronRight,
  ChevronsDown,
  Eye,
  EyeOff,
  Users,
  User,
  Briefcase,
  Activity,
  Flame,
  Inbox,
  ShieldCheck,
  Coins,
  Crown,
} from "lucide-react";
import { hexToRgba } from "../../Components/HexToRgba";

const incomeIconMap = {
  roi_income: TrendingUp,
  reward_income: DollarSign,
  direct_income: Target,
  roi_level_income: BarChart2,
  token_income: Wallet,
};

// Accent series for income streams / chart (light theme)
const seriesColors = [
  "#ff8500",
  "#2f7bf6",
  "#e5368f",
  "#7c4dff",
  "#14b371",
  "#ffc247",
  "#00a3c4",
];

const getBgColor = (color) => hexToRgba(color, 0.12);

// Hero / summary artwork (public/images/dashboard)
const WALLET_ART = `${process.env.PUBLIC_URL}/images/dashboard/wallet-hero.png`;
const BANNER_ART = `${process.env.PUBLIC_URL}/images/dashboard/package-banner.jpg`;

/* ---------- Decorative graphics for the statistic cards ---------- */
const ArtBars = () => (
  <svg viewBox="0 0 120 90" aria-hidden="true">
    {[18, 30, 44, 60].map((h, i) => (
      <rect key={i} x={10 + i * 26} y={86 - h} width="16" height={h} rx="4" fill="currentColor" opacity={0.25 + i * 0.15} />
    ))}
    <polyline points="10,62 36,48 62,52 88,26 112,12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
    <circle cx="112" cy="12" r="4.5" fill="currentColor" />
  </svg>
);

const ArtArrow = () => (
  <svg viewBox="0 0 120 100" aria-hidden="true">
    {[20, 34, 50].map((h, i) => (
      <rect key={i} x={14 + i * 24} y={96 - h} width="16" height={h} rx="4" fill="currentColor" opacity={0.2 + i * 0.15} />
    ))}
    <rect x="86" y="30" width="16" height="66" rx="4" fill="currentColor" opacity="0.65" />
    <path d="M94 4 L112 26 H101 V40 H87 V26 H76 Z" fill="currentColor" />
  </svg>
);

const ArtPeople = () => (
  <svg viewBox="0 0 120 90" aria-hidden="true">
    <circle cx="30" cy="34" r="12" fill="currentColor" opacity="0.35" />
    <path d="M8 84c0-14 10-26 22-26s22 12 22 26z" fill="currentColor" opacity="0.3" />
    <circle cx="90" cy="34" r="12" fill="currentColor" opacity="0.35" />
    <path d="M68 84c0-14 10-26 22-26s22 12 22 26z" fill="currentColor" opacity="0.3" />
    <circle cx="60" cy="26" r="15" fill="currentColor" opacity="0.6" />
    <path d="M32 88c0-18 12-32 28-32s28 14 28 32z" fill="currentColor" opacity="0.55" />
  </svg>
);

const ArtNetwork = () => {
  const nodes = [[20, 60], [52, 22], [92, 34], [76, 74], [40, 84], [108, 70]];
  const links = [[0, 1], [1, 2], [2, 3], [3, 4], [4, 0], [1, 3], [2, 5], [3, 5]];
  return (
    <svg viewBox="0 0 124 100" aria-hidden="true">
      {links.map(([a, b], i) => (
        <line key={i} x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]} stroke="currentColor" strokeWidth="2.5" opacity="0.35" />
      ))}
      {nodes.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={i === 1 || i === 3 ? 11 : 8} fill="currentColor" opacity={i === 1 || i === 3 ? 0.75 : 0.5} />
      ))}
    </svg>
  );
};

const DashboardNew = () => {
  const [flushIncome, setFlushIncome] = useState(0);
  const [newsData, setNewsData] = useState();
  const dispatch = useDispatch();
  const { AxiosGet } = useAxiosHelper();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const teamData = useSelector((state) => state.teamData?.teamSection);
  const [packageData, setPackageData] = useState([]);
  const [totalIncome, setTotalIncome] = useState();
  const authToken = useSelector((state) => state.userStatus.authToken);
  const showDashPopup = useSelector((state) => state.userStatus.showDashPopup);
  const [, setCappingBarData] = useState([]);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const profileData = useSelector(
    (state) => state.profileData.userPersonalInfo
  );
  const [showBalance, setShowBalance] = useState(true);
  const [recentHistory, setRecentHistory] = useState([]);

  var y = 0;
  useEffect(() => {
    if (y == 0) {
      if (profileData?.profile_edit_status == 0) {
        setShowAlertPopup(true);
      }
      y++;
    }
  }, [profileData]);

  useEffect(() => {
    fetchData();
    FetchOrderHistory();
    fetchPopupNews();
    getFetchOrder();
  }, [authToken]);

  // Refresh wallet balances live when a deposit is credited (real-time event
  // dispatched by DepositNotifier on a WebSocket "deposit_success" message).
  useEffect(() => {
    const onDeposit = () => {
      fetchData();
      fetchCappingBar();
    };
    window.addEventListener("deposit_success", onDeposit);
    return () => window.removeEventListener("deposit_success", onDeposit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchPopupNews() {
    if (showDashPopup == true) {
      const queryParams = new URLSearchParams({ popup: 1 });
      const queryString = queryParams.toString();
      const tempData = await AxiosGet(
        `${ApiPaths.announcement}?${queryString}`
      );
      setNewsData(tempData?.data);
    }
  }

  const FetchOrderHistory = async () => {
    try {
      setLoading(true);
      const response = await AxiosGet(ApiPaths.getPaymentTransaction);
      const allOrders = response?.data || [];
      const recentOrders = allOrders.slice(0, 5);
      setRecentHistory(recentOrders);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching order history:", error);
      toastFailed(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const capitalizeFirstWords = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  async function fetchCappingBar() {
    try {
      const res = await AxiosGet(ApiPaths.getCappingBar);
      setCappingBarData(res);
    } catch (error) {
      toastFailed(error?.message);
      BasicInfo.isDebug && console.log(error);
    }
  }

  async function fetchData() {
    setLoading(true);
    try {
      const [res1, res2, tempTeam, packagesRes] = await Promise.all([
        AxiosGet(ApiPaths.getProfile),
        AxiosGet(ApiPaths.getWallets),
        AxiosGet(ApiPaths.getTeams),
        AxiosGet(ApiPaths.getPackages),
      ]);
      if (res1) dispatch(setUserPersonalInfo(res1));
      if (res2) {
        dispatch(setIncomeWallet(res2?.wallets));
        setTotalIncome(res2?.totalIncome);
        setFlushIncome(res2?.flush_income);
      }
      if (tempTeam) dispatch(setTeamSection(tempTeam));
      if (packagesRes) setPackageData(packagesRes);
    } catch (error) {
      toastFailed(error?.tempTeam?.message);
      BasicInfo.isDebug && console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const getFetchOrder = async () => {
    try {
      setLoading(true);
      await AxiosGet(ApiPaths.getOrders);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  var z = 0;
  useEffect(() => {
    if (profileData?.uid) {
      if (z == 0) {
        fetchCappingBar();
        z++;
      }
    }
  }, [profileData?.uid]);

  const handleIncome = (slug) => {
    navigate(`/incomes`, { state: { incomeSlug: slug } });
  };

  const sourceName = (slug) => {
    const name = incomeData?.find((x) => x?.slug === slug);
    return name ? name.name : "";
  };

  const getFormattedSource = (source) => {
    if (!source) return "";
    const incomeSource = sourceName(source);
    if (incomeSource) {
      return incomeSource;
    } else if (source === "topup") {
      return "Package Buy";
    } else {
      return capitalizeFirstWords(source.split("_").join(" "));
    }
  };

  /* ---------- derived data ---------- */
  const walletsArr = Array.isArray(incomeData) ? incomeData : [];

  // Spendable dollar wallets (Main Wallet, Fund Wallet, …). Exclude the
  // token wallet — it holds project tokens, not dollars, and must not be
  // mixed into the dollar Total Balance.
  const spendableWallets = walletsArr.filter(
    (x) =>
      (x?.wallet_type === "wallet" && x?.slug !== "token_wallet") ||
      x?.slug === "promo_airdrop"
  );
  const incomeWallets = walletsArr.filter(
    (x) => x?.wallet_type === "income" && x?.slug !== "promo_airdrop"
  );

  // Total Balance = sum of the spendable dollar wallets (Main + Fund + …).
  const totalBalance = spendableWallets.reduce(
    (sum, x) => sum + (parseFloat(x?.value) || 0),
    0
  );

  // Token income is a separate reward (paid in project tokens), so it must not
  // be mixed into the dollar "Total Income".
  const TOKEN_SLUG = "token_income";
  const tokenIncome = walletsArr
    .filter((x) => x?.slug === TOKEN_SLUG)
    .reduce((sum, x) => sum + (parseFloat(x?.value) || 0), 0);
  const dollarIncome = (parseFloat(totalIncome) || 0) - tokenIncome;

  const fmt = (n) =>
    (parseFloat(n) || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  // Short form for the narrow summary columns ($12.4K, $1.2M)
  const fmtShort = (n) => {
    const v = parseFloat(n) || 0;
    if (Math.abs(v) < 10000) return fmt(v);
    return v.toLocaleString("en-US", {
      notation: "compact",
      maximumFractionDigits: 1,
    });
  };
  const mask = "••••••";
  const money = (n) => (showBalance ? `$${fmt(n)}` : mask);
  const moneyShort = (n) => (showBalance ? `$${fmtShort(n)}` : mask);
  // Phone summary columns are ~80px wide: compact from $1K up ($7.3K)
  const moneyTiny = (n) => {
    if (!showBalance) return "•••";
    const v = parseFloat(n) || 0;
    if (Math.abs(v) < 1000) return `$${fmt(v)}`;
    return `$${v.toLocaleString("en-US", { notation: "compact", maximumFractionDigits: 1 })}`;
  };

  const cappingLimit = parseFloat(packageData?.totalCappedAmount) || 0;
  const cappingInvested = parseFloat(packageData?.totalOrderAmount) || 0;
  // Income that counts toward the 10x package capping = level income only
  // (token income is a separate reward). Matches the backend get-all-package rule.
  const CAPPING_INCOME_SLUGS = [
    "level_income",
    "roi_income",
    "roi_level_income",
    "infinity_income",
  ];
  const cappingEarnedFromWallets = walletsArr
    .filter(
      (x) => x?.wallet_type === "income" && CAPPING_INCOME_SLUGS.includes(x?.slug)
    )
    .reduce((sum, x) => sum + (parseFloat(x?.value) || 0), 0);
  const cappingEarned =
    cappingEarnedFromWallets || parseFloat(packageData?.totalIncome) || 0;
  const cappingPct =
    cappingLimit > 0 ? Math.min(100, (cappingEarned / cappingLimit) * 100) : 0;

  // Income as a percentage of capital invested (0 when nothing invested yet)
  const incomePct = cappingInvested > 0 ? (dollarIncome / cappingInvested) * 100 : 0;

  // Income breakdown chart — dollar incomes only (token income is a separate unit)
  const chartIncomes = incomeWallets.filter((x) => x?.slug !== TOKEN_SLUG);
  const chartTotal = chartIncomes.reduce(
    (s, x) => s + (parseFloat(x?.value) || 0),
    0
  );
  const chartData = chartIncomes.map((x, i) => ({
    name: x?.name,
    slug: x?.slug,
    value: parseFloat(x?.value) || 0,
    color: seriesColors[i % seriesColors.length],
  }));
  const hasChart = chartTotal > 0;

  const totalTeam = teamData?.sum?.total_team ?? 0;
  const activeTeam = teamData?.sum?.active_team ?? 0;
  const teamBusiness = teamData?.sum?.business;
  const hasBusiness = teamBusiness !== undefined && teamBusiness !== null;

  const summary = [
    { label: "Invested", value: moneyShort(cappingInvested), tiny: moneyTiny(cappingInvested), Icon: TrendingUp, tone: "mint", to: "/package" },
    { label: "Income", value: moneyShort(dollarIncome), tiny: moneyTiny(dollarIncome), Icon: Wallet, tone: "blue", to: "/incomes" },
    { label: "Team", value: totalTeam, tiny: totalTeam, Icon: Users, tone: "violet", to: "/direct_team" },
    {
      label: "Team Business",
      value: hasBusiness ? moneyShort(teamBusiness) : "—",
      tiny: hasBusiness ? moneyTiny(teamBusiness) : "—",
      Icon: User,
      tone: "orange",
      to: "/my_team",
    },
  ];

  const stats = [
    {
      label: "Total Invested",
      value: money(cappingInvested),
      sub: "Across all packages",
      Icon: BarChart3,
      tone: "mint",
      Art: ArtBars,
      to: "/package",
    },
    {
      label: "Total Income",
      value: money(dollarIncome),
      sub: tokenIncome > 0 ? `+ ${fmt(tokenIncome)} tokens` : "Lifetime earnings",
      Icon: Briefcase,
      tone: "blue",
      Art: ArtArrow,
      to: "/incomes",
    },
    {
      label: "Team Members",
      value: totalTeam,
      sub: `${activeTeam} active`,
      Icon: Users,
      tone: "violet",
      Art: ArtPeople,
      to: "/direct_team",
    },
    {
      label: "Team Business",
      value: hasBusiness ? money(teamBusiness) : "—",
      sub: "Total network volume",
      Icon: Activity,
      tone: "pink",
      Art: ArtNetwork,
      to: "/my_team",
    },
  ];

  const ChartTip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const p = payload[0];
    const pct = chartTotal ? ((p.value / chartTotal) * 100).toFixed(1) : 0;
    return (
      <div className="ax-chart-tip">
        <b>{p.name}</b>
        {showBalance ? `$${fmt(p.value)}` : mask} · {pct}%
      </div>
    );
  };

  const isInitialLoad = loading && !walletsArr.length;

  return (
    <>
      {showAlertPopup && (
        <div
          className="alert-popup-overlay"
          onClick={() => setShowAlertPopup(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="alert-popup-title"
        >
          <div
            className="alert-popup-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="alert-popup-close"
              onClick={() => setShowAlertPopup(false)}
              aria-label="Close"
            >
              ×
            </button>
            <div className="alert-popup-icon-wrap">
              <GoAlertFill className="alert-popup-icon" />
            </div>
            <h2 id="alert-popup-title" className="alert-popup-title">
              Profile update required
            </h2>
            <p className="alert-popup-message">
              Please complete your profile before continuing to use the dashboard.
            </p>
            <div className="alert-popup-actions">
              <button
                type="button"
                className="alert-popup-btn secondary"
                onClick={() => setShowAlertPopup(false)}
              >
                Later
              </button>
              <button
                type="button"
                className="alert-popup-btn primary"
                onClick={() => navigate("/profile")}
              >
                Update profile
              </button>
            </div>
          </div>
        </div>
      )}
      {profileData?.profile_edit_status == 1 && newsData && newsData.length > 0
        ? showDashPopup && (
          <div
            className="popup-overlay"
            onClick={() => dispatch(setShowDashPopup(false))}
          >
            <div className="popup-container">
              <h2>Latest News</h2>
              <h3 style={{ color: "var(--colorPrimary)" }}>
                {newsData[0]?.title || "No Title Available"}
              </h3>
              {newsData[0]?.image ? (
                <img
                  src={newsData[0]?.image}
                  alt="News"
                  style={{ width: "200px" }}
                />
              ) : null}
              <p>{newsData[0]?.description || "No description available."}</p>
            </div>
          </div>
        )
        : null}

      <section className="ax-dash">
        {/* ---------- HERO + SUMMARY ---------- */}
        <div className="ax-hero-wrap ax-rise">
          <div className="ax-hero">
            <div className="ax-hero-text">
              <div className="ax-hero-label">
                Total Balance
                <button
                  type="button"
                  className="ax-eye"
                  onClick={() => setShowBalance((v) => !v)}
                  aria-label={showBalance ? "Hide balances" : "Show balances"}
                >
                  {showBalance ? <Eye size={16} /> : <EyeOff size={16} />}
                </button>
              </div>
              <div className="ax-hero-value">
                {isInitialLoad ? (
                  <span className="ax-skel" style={{ width: 170, height: 44 }} />
                ) : showBalance ? (
                  `$${fmt(totalBalance)}`
                ) : (
                  mask
                )}
              </div>
              <div className="ax-hero-chips">
                <span
                  className="ax-income-chip"
                  title="Total income · income as a percentage of invested capital"
                >
                  <TrendingUp size={16} />
                  Income {money(dollarIncome)}
                  <i className="ax-chip-sep" />
                  <span className="ax-chip-pct">
                    {showBalance ? `${incomePct.toFixed(2)}%` : "••"}
                  </span>
                </span>
                {parseFloat(flushIncome) > 0 && (
                  <span className="ax-mini-chip burn">
                    <Flame size={13} /> Burned {money(flushIncome)}
                  </span>
                )}
                {tokenIncome > 0 && (
                  <span className="ax-mini-chip token">
                    <Coins size={13} /> {showBalance ? fmt(tokenIncome) : mask} tokens
                  </span>
                )}
              </div>
            </div>

            <div className="ax-hero-art" aria-hidden="true">
              <span className="ax-hero-orbit" />
              <img src={WALLET_ART} alt="" className="ax-hero-wallet" draggable="false" />
            </div>

            <div className="ax-slogan" aria-hidden="true">
              <Crown size={18} />
              <span>Build</span>
              <span>Earn</span>
              <span>Grow</span>
            </div>
          </div>

          <div className="ax-summary">
            {summary.map(({ label, value, tiny, Icon, tone, to }) => (
              <button
                key={label}
                type="button"
                className={`ax-sum tone-${tone}`}
                onClick={() => navigate(to)}
              >
                <span className="ax-sum-icon">
                  <Icon size={20} />
                </span>
                <span className="ax-sum-label">{label}</span>
                <span className="ax-sum-value" title={typeof value === "string" ? value : undefined}>
                  <span className="ax-v-full">{value}</span>
                  <span className="ax-v-tiny">{tiny}</span>
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* ---------- DEPOSIT / WITHDRAW ---------- */}
        <div className="ax-ctas ax-rise ax-d1">
          <button type="button" className="ax-cta deposit" onClick={() => navigate("/deposit")}>
            <span className="ax-cta-icon">
              <Coins size={24} />
            </span>
            <span className="ax-cta-text">
              <b>+ Deposit</b>
              <small>Add funds to your wallet</small>
            </span>
            <ChevronRight size={20} className="ax-cta-chev" />
          </button>
          <button type="button" className="ax-cta withdraw" onClick={() => navigate("/claim")}>
            <span className="ax-cta-icon">
              <ArrowUpRight size={22} />
            </span>
            <span className="ax-cta-text">
              <b>Withdraw</b>
              <small>Get your earnings</small>
            </span>
            <ChevronRight size={20} className="ax-cta-chev" />
          </button>
        </div>

        {/* ---------- STATISTICS ---------- */}
        <div className="ax-stats ax-rise ax-d2">
          {stats.map(({ label, value, sub, Icon, tone, Art, to }) => (
            <button
              key={label}
              type="button"
              className={`ax-stat tone-${tone}`}
              onClick={() => navigate(to)}
            >
              <span className="ax-stat-art">
                <Art />
              </span>
              <span className="ax-stat-icon">
                <Icon size={22} />
              </span>
              <span className="ax-stat-label">{label}</span>
              <span className="ax-stat-value">
                {isInitialLoad ? <span className="ax-skel" style={{ width: 90, height: 26 }} /> : value}
              </span>
              <span className="ax-stat-sub">{sub}</span>
              <span className="ax-stat-go">
                <ChevronRight size={16} />
              </span>
            </button>
          ))}
        </div>

        {/* ---------- FEATURED PACKAGE / CAPPING ---------- */}
        <button
          type="button"
          className="ax-banner ax-rise ax-d3"
          onClick={() => navigate("/package")}
          style={{ "--banner-art": `url(${BANNER_ART})` }}
        >
          <span className="ax-banner-body">
            <span className="ax-banner-eyebrow">Featured package</span>
            <span className="ax-banner-title">
              Package Capping <i>·</i> <em>10x</em>
            </span>
            <span className="ax-banner-sub">Earnings limit against your invested capital</span>
            <span className="ax-banner-pill">
              <ShieldCheck size={14} />
              {cappingPct >= 100 ? "Capped" : "Earning"}
            </span>
            <span className="ax-banner-progress">
              <span className="ax-banner-bar">
                <span style={{ width: `${cappingPct}%` }} />
              </span>
              <span className="ax-banner-meta">
                {money(cappingEarned)} of {money(cappingLimit)} · {cappingPct.toFixed(0)}%
                {parseFloat(flushIncome) > 0 ? ` · Burned ${money(flushIncome)}` : ""}
              </span>
            </span>
          </span>
          <span className="ax-banner-cue" aria-hidden="true">
            <Crown size={16} />
            <ChevronsDown size={18} />
          </span>
        </button>

        {/* ---------- DETAILS ---------- */}
        <div className="ax-main">
          <div className="ax-col">
            {incomeWallets.length > 0 && (
              <div className="ax-sec ax-rise ax-d3">
                <div className="ax-sec-head">
                  <h2>Income Overview</h2>
                  <button type="button" className="ax-link" onClick={() => navigate("/incomes")}>
                    See all <ChevronRight size={15} />
                  </button>
                </div>
                <div className="ax-income-grid">
                  {incomeWallets.map((x, i) => {
                    const Icon = incomeIconMap[x?.slug] || DollarSign;
                    const color = seriesColors[i % seriesColors.length];
                    const isToken = x?.slug === TOKEN_SLUG;
                    const val = parseFloat(x?.value) || 0;
                    const share = !isToken && chartTotal > 0 ? (val / chartTotal) * 100 : 0;
                    return (
                      <button
                        key={x?.slug ?? i}
                        type="button"
                        className="ax-card ax-income"
                        style={{ "--inc-color": color, "--inc-bg": getBgColor(color) }}
                        onClick={() => handleIncome(x?.slug)}
                      >
                        <span className="ax-income-top">
                          <span className="ax-income-icon">
                            <Icon size={19} />
                          </span>
                          <ArrowUpRight size={16} className="ax-income-arrow" />
                        </span>
                        <span className="ax-income-label" title={x?.name}>
                          {x?.name}
                        </span>
                        <span className="ax-income-value">
                          {showBalance
                            ? `${isToken ? "" : "$"}${fmt(val)}${isToken ? " tokens" : ""}`
                            : mask}
                        </span>
                        {!isToken && (
                          <span className="ax-income-share">
                            <span className="ax-share-bar">
                              <span style={{ width: `${share}%` }} />
                            </span>
                            {share.toFixed(0)}%
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="ax-sec ax-rise ax-d4">
              <div className="ax-sec-head">
                <h2>Income Breakdown</h2>
              </div>
              <div className="ax-card ax-pad ax-chart-card">
                <div className="ax-chart-wrap">
                  {hasChart ? (
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={chartData}
                          dataKey="value"
                          nameKey="name"
                          innerRadius="68%"
                          outerRadius="100%"
                          paddingAngle={3}
                          stroke="none"
                          isAnimationActive
                        >
                          {chartData.map((d) => (
                            <Cell key={d.slug} fill={d.color} />
                          ))}
                        </Pie>
                        <Tooltip content={<ChartTip />} />
                      </PieChart>
                    </ResponsiveContainer>
                  ) : (
                    <svg viewBox="0 0 100 100" width="100%" height="100%">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#f1ebe2" strokeWidth="14" />
                    </svg>
                  )}
                  <div className="ax-chart-center">
                    <b>{money(chartTotal)}</b>
                    <span>Total income</span>
                  </div>
                </div>
                <div className="ax-legend">
                  {hasChart ? (
                    chartData.map((d) => (
                      <button
                        key={d.slug}
                        type="button"
                        className="ax-legend-row"
                        onClick={() => handleIncome(d.slug)}
                      >
                        <span className="ax-swatch" style={{ background: d.color }} />
                        <span className="ax-legend-name">{d.name}</span>
                        <span className="ax-legend-pct">
                          {((d.value / chartTotal) * 100).toFixed(1)}%
                        </span>
                        <span className="ax-legend-val">{money(d.value)}</span>
                      </button>
                    ))
                  ) : (
                    <div className="ax-empty">
                      <Inbox size={28} />
                      Your income breakdown will appear here once earnings start.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="ax-col">
            {spendableWallets.length > 0 && (
              <div className="ax-sec ax-rise ax-d4">
                <div className="ax-sec-head">
                  <h2>My Wallets</h2>
                  <button type="button" className="ax-link" onClick={() => navigate("/transaction_history")}>
                    History <ChevronRight size={15} />
                  </button>
                </div>
                <div className="ax-card ax-pad">
                  <div className="ax-list">
                    {spendableWallets.map((x, i) => {
                      const isMtx = x?.slug === "swap_wallet";
                      const color = seriesColors[i % seriesColors.length];
                      return (
                        <button
                          key={x?.slug ?? i}
                          type="button"
                          className="ax-row"
                          onClick={() => x?.slug && handleIncome(x.slug)}
                        >
                          <span className="ax-row-left">
                            <span className="ax-row-icon" style={{ background: getBgColor(color), color }}>
                              <Wallet size={19} />
                            </span>
                            <span className="ax-row-info">
                              <span className="ax-row-title">{x?.name}</span>
                              <span className="ax-row-sub">
                                {isMtx ? "Token balance" : "Available balance"}
                              </span>
                            </span>
                          </span>
                          <span className="ax-row-amt">
                            {showBalance
                              ? isMtx
                                ? `MTX ${fmt(x?.value)}`
                                : `$${fmt(x?.value)}`
                              : mask}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            <div className="ax-sec ax-rise ax-d5">
              <div className="ax-sec-head">
                <h2>Recent Activity</h2>
                <button type="button" className="ax-link" onClick={() => navigate("/transaction_history")}>
                  See all <ChevronRight size={15} />
                </button>
              </div>
              <div className="ax-card ax-pad">
                <div className="ax-list">
                  {recentHistory.length && recentHistory?.status != 2 ? (
                    recentHistory?.map((x, i) => {
                      const isCredit = x?.debit_credit === "credit";
                      const amount = fmt(x?.amount);
                      const statusLabel = x?.status === 1 ? "completed" : "pending";
                      const formattedSource = getFormattedSource(x?.source);
                      return (
                        <button
                          type="button"
                          className="ax-row"
                          key={i}
                          onClick={() => navigate("/transaction_history")}
                        >
                          <span className="ax-row-left">
                            <span className={`ax-row-icon ${isCredit ? "credit" : "debit"}`}>
                              {isCredit ? <ArrowDownLeft size={18} /> : <ArrowUpRight size={18} />}
                            </span>
                            <span className="ax-row-info">
                              <span className="ax-row-title">{formattedSource}</span>
                              <span className="ax-row-sub">{moment(x?.time).fromNow()}</span>
                            </span>
                          </span>
                          <span className="ax-row-right">
                            <span className={`ax-row-amt ${isCredit ? "credit" : "debit"}`}>
                              {isCredit ? "+" : "-"}
                              {x?.source == TOKEN_SLUG ? "" : "$"}
                              {amount}
                            </span>
                            <span className={`ax-status ${x?.status === 1 ? "done" : "pending"}`}>
                              {statusLabel}
                            </span>
                          </span>
                        </button>
                      );
                    })
                  ) : (
                    <div className="ax-empty">
                      <Inbox size={28} />
                      No activity yet — your deposits and earnings will show up here.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardNew;
